import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Grid } from "@material-ui/core";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import CustomSelectNew from "components/UpdateUi/CustomeSelect";
import ToastModal from "views/components/ToastModal";
import CustomeTextField from "components/UpdateUi/CustomeTextField";
import { schemeChannelOptions } from "assets/properties/properties";
import { sourceOptions } from "assets/properties/properties";

const RenewalTopUpValidationCreate = ({ classes }) => {
  const navigate = useNavigate();
  const params = useParams();
  const { authToken } = useSelector((state) => state.login.authData);

  const [callInProgress, setCallInProgress] = useState(false);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const [type, setType] = useState("");
  const [source, setSource] = useState("");
  const [enabled, setEnabled] = useState(false);
  const [auditedPacketEnabled, setAuditedPacketEnabled] = useState(false);
  const [legalMarkingEnabled, setLegalMarkingEnabled] = useState(false);
  const [redirectURL, setRedirectURL] = useState("");
  const [maxEligibleDaysBeforeMaturity, setMaxEligibleDaysBeforeMaturity] =
    useState("");
  const [thresholdLtv, setThresholdLtv] = useState("");
  const [lockInPeriod, setLockInPeriod] = useState("");
  const [loanPercentage, setLoanPercentage] = useState("");

  const [disabledButton, setDisabledButton] = useState(true);
  const [existingTypes, setExistingTypes] = useState([]);
  const [schemeChannel, setSchemeChannel] = useState("");

  const [overdueRestrictionEnabled, setOverdueRestrictionEnabled] = useState(false);
  const [npaEnabled, setNpaEnabled] = useState(false);
  const [pendingInterestEnabled, setPendingInterestEnabled] = useState(false);
  const [disbursalExistEnabled, setDisbursalExistEnabled] = useState(false);
  const [payableExistEnabled, setPayableExistEnabled] = useState(false);
  const [maxTopUpAmountEnabled, setMaxTopUpAmountEnabled] = useState(false);
  const [skipSchemeCalculation, setSkipSchemeCalculation]= useState(false);
  const [activeLoansNumber, setActiveLoanNumber]=useState("")
  const [loanMaturedEnabled, setLoanMaturedEnabled]=useState(true)
  const [auditActionEnabled, setAuditActionEnabled]=useState(false)

  const [typeOptions, setTypeOptions] = useState([
    {
      code: "TOPUP",
      name: "Top-Up",
      disabled: false,
    },
    {
      code: "RENEWAL",
      name: "Renewal",
      disabled: false,
    },
  ]);
  useEffect(() => {
    if (source?.toLowerCase() === "mobile") {
      setMaxTopUpAmountEnabled(true);
      setSkipSchemeCalculation(false);
    } else if (source?.toLowerCase() === "web") {
      setMaxTopUpAmountEnabled(false);
      setSkipSchemeCalculation(true);
    }
  }, [source]);
  useEffect(() => {
    (async () => {
      setCallInProgress(true);
      const res = await apiHandler({
        url: endpoint.RENEWAL_TOP_UP_VALIDATION_FINDALL,
        authToken,
      });
      setCallInProgress(false);

      const data = res?.data || [];
      const types = data.map((item) => item.type);
      setExistingTypes(types);

      setTypeOptions([
        {
          code: "TOPUP",
          name: "Top-Up",
          disabled: !params.id && types.includes("TOPUP"),
        },
        {
          code: "RENEWAL",
          name: "Renewal",
          disabled: !params.id && types.includes("RENEWAL"),
        },
      ]);

      if (params?.id) {
        const record = data.find((item) => item.id === Number(params.id));
        if (record) {
          setType(record.type);
          setEnabled(record.enabled);
          setAuditedPacketEnabled(record.auditedPacketEnabled);
          setLegalMarkingEnabled(record.legalMarkingEnabled);
          setMaxEligibleDaysBeforeMaturity(
            record.maxEligibleDaysBeforeMaturity
          );
          setThresholdLtv(record.thresholdLtv);
          setLockInPeriod(record.lockInPeriod);
          setLoanPercentage(record.loanPercentage);
          setSchemeChannel(record.schemeChannel);
          setOverdueRestrictionEnabled(record.overdueRestrictionEnabled);
          setNpaEnabled(record.npaEnabled);
          setPendingInterestEnabled(record.pendingInterestEnabled);
          setDisbursalExistEnabled(record.disbursalExistEnabled);
          setPayableExistEnabled(record.payableExistEnabled);
          setSchemeChannel(record.schemeChannel);
          setMaxTopUpAmountEnabled(record.maxTopUpAmountEnabled);
          setSource(record.source);
          setSkipSchemeCalculation(record.skipCalculation)
          setAuditActionEnabled(record.auditActionEnabled);
          setLoanMaturedEnabled(record.loanMaturedEnabled);
          setActiveLoanNumber(record.activeLoansCount)
        }
      }
    })();
  }, []);

  useEffect(() => {

    if (
      type &&
      schemeChannel &&
      maxEligibleDaysBeforeMaturity !== "" &&
      thresholdLtv !== "" &&
      lockInPeriod !== "" &&
      loanPercentage !== ""
    ) {
      setDisabledButton(false);
    } else {
      setDisabledButton(true);
    }
  }, [
    type,
    maxEligibleDaysBeforeMaturity,
    thresholdLtv,
    lockInPeriod,
    loanPercentage,
    existingTypes,
    schemeChannel,
  ]);

  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
    if (redirectURL !== "") {
      setRedirectURL("");
      navigate(redirectURL);
    }
  };

  const handleSubmit = async () => {
    if (!params.id && existingTypes.includes(type)) {
      toastUpdate("Error", `${type} configuration already exists`, true);
      return;
    }

    setCallInProgress(true);
    const res = await apiHandler({
      url: params.id
        ? endpoint.RENEWAL_TOP_UP_VALIDATION_UPDATE + params.id
        : endpoint.RENEWAL_TOP_UP_VALIDATION_CREATE,
      method: params.id ? "PUT" : "POST",
      authToken,
      data: {
        type,
        schemeChannel,
        enabled,
        auditedPacketEnabled,
        legalMarkingEnabled,
        overdueRestrictionEnabled,
        npaEnabled,
        pendingInterestEnabled,
        disbursalExistEnabled,
        payableExistEnabled,
        maxTopUpAmountEnabled,
        maxEligibleDaysBeforeMaturity: Number(maxEligibleDaysBeforeMaturity),
        thresholdLtv: Number(thresholdLtv),
        lockInPeriod: Number(lockInPeriod),
        loanPercentage: Number(loanPercentage),
        source,
        skipCalculation: skipSchemeCalculation,
        activeLoansCount: Number(activeLoansNumber),
        loanMaturedEnabled:loanMaturedEnabled,
        auditActionEnabled:auditActionEnabled
      },
    });
    setCallInProgress(false);

    if (res?.data?.error_code) {
      toastUpdate("Error", res.data.user_description, true);
    } else {
      toastUpdate(
        "Success",
        params.id
          ? "Configuration updated successfully!"
          : "Configuration created successfully!",
        true
      );
      setRedirectURL("/coreservice/renewalTopUpValidation");
    }
  };
  const handleOnlyNumber = (value, setter) => {
    const regex = /^\d*$/;
    if (value === "" || regex.test(value)) {
      setter(value);
    }
  };

  const handleNumberWithDecimal = (value, setter) => {
    const regex = /^\d*\.?\d*$/;
    if (value === "" || regex.test(value)) {
      setter(value);
    }
  };
  return (
    <Grid container>
      <Grid item xs={12}>
        <SubHeader
          label={params.id ? "Edit Configuration" : "Create Configuration"}
          button1="Save"
          button2="Cancel"
          button1click={handleSubmit}
          button2click={() => navigate("/coreservice/renewalTopUpValidation")}
          disabled1={disabledButton}
        />
      </Grid>
      <Grid item xs={12} className={classes.inputContainer}>
        <Grid container className={classes.inputFieldContainer}>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomSelectNew
              label="Source*"
              id="type"
              value={source}
              setState={setSource}
              data={sourceOptions}
              type="TYPE"
              disabled={params?.id ? true : false}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomSelectNew
              label="Type*"
              id="type"
              value={type}
              setState={setType}
              data={typeOptions}
              type="TYPE"
              disabled={params?.id ? true : false}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomSelectNew
              label="Scheme Channel*"
              id="schemeChannel"
              value={schemeChannel}
              setState={setSchemeChannel}
              data={schemeChannelOptions}
              type="TYPE"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <label
              style={{ display: "flex", alignItems: "center", gap: "20px" }}
            >
              <input
                type="checkbox"
                checked={enabled}
                style={{ width: "30px", height: "30px" }}
                onChange={(e) => setEnabled(e.target.checked)}
              />
              Enabled
            </label>
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <label
              style={{ display: "flex", alignItems: "center", gap: "20px" }}
            >
              <input
                type="checkbox"
                checked={auditedPacketEnabled}
                style={{ width: "30px", height: "30px" }}
                onChange={(e) => setAuditedPacketEnabled(e.target.checked)}
              />
              Audited Packet Enabled
            </label>
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <label
              style={{ display: "flex", alignItems: "center", gap: "20px" }}
            >
              <input
                type="checkbox"
                checked={legalMarkingEnabled}
                style={{ width: "30px", height: "30px" }}
                onChange={(e) => setLegalMarkingEnabled(e.target.checked)}
              />
              Legal Marking Enabled
            </label>
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <label style={{ display: "flex", alignItems: "center", gap: "20px" }}>
              <input
                type="checkbox"
                checked={overdueRestrictionEnabled}
                style={{ width: "30px", height: "30px" }}
                onChange={(e) => setOverdueRestrictionEnabled(e.target.checked)}
              />
              Overdue Restriction Enabled
            </label>
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <label style={{ display: "flex", alignItems: "center", gap: "20px" }}>
              <input
                type="checkbox"
                checked={npaEnabled}
                style={{ width: "30px", height: "30px" }}
                onChange={(e) => setNpaEnabled(e.target.checked)}
              />
              NPA Enabled
            </label>
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <label style={{ display: "flex", alignItems: "center", gap: "20px" }}>
              <input
                type="checkbox"
                checked={pendingInterestEnabled}
                style={{ width: "30px", height: "30px" }}
                onChange={(e) => setPendingInterestEnabled(e.target.checked)}
              />
              Pending Interest Enabled
            </label>
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <label style={{ display: "flex", alignItems: "center", gap: "20px" }}>
              <input
                type="checkbox"
                checked={disbursalExistEnabled}
                style={{ width: "30px", height: "30px" }}
                onChange={(e) => setDisbursalExistEnabled(e.target.checked)}
              />
              Disbursal Exist Enabled
            </label>
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <label style={{ display: "flex", alignItems: "center", gap: "20px" }}>
              <input
                type="checkbox"
                checked={payableExistEnabled}
                style={{ width: "30px", height: "30px" }}
                onChange={(e) => setPayableExistEnabled(e.target.checked)}
              />
              Payable Exist Enabled
            </label>
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <label style={{ display: "flex", alignItems: "center", gap: "20px" }}>
              <input
                type="checkbox"
                checked={maxTopUpAmountEnabled}
                style={{ width: "30px", height: "30px" }}
                onChange={(e) => setMaxTopUpAmountEnabled(e.target.checked)}
                disabled
              />
              Max Top-Up Amount Enabled
            </label>
          </Grid>
              <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <label style={{ display: "flex", alignItems: "center", gap: "20px" }}>
              <input
                type="checkbox"
                checked={skipSchemeCalculation}
                style={{ width: "30px", height: "30px" }}
                onChange={(e) => setSkipSchemeCalculation(e.target.checked)}
                disabled
              />
                Skip Scheme Calculation
            </label>
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <label style={{ display: "flex", alignItems: "center", gap: "20px" }}>
              <input
                type="checkbox"
                checked={loanMaturedEnabled}
                style={{ width: "30px", height: "30px" }}
                onChange={(e) => setLoanMaturedEnabled(e.target.checked)}
                disabled={type === "TOPUP"}
              />
              Loan Matured Enabled
            </label>
          </Grid>
           <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <label style={{ display: "flex", alignItems: "center", gap: "20px" }}>
              <input
                type="checkbox"
                checked={auditActionEnabled}
                style={{ width: "30px", height: "30px" }}
                onChange={(e) => setAuditActionEnabled(e.target.checked)}
              />
             Audit Action Enabled
            </label>
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Max Eligible Days Before Maturity"
              value={maxEligibleDaysBeforeMaturity}
              setState={(e) =>
                handleOnlyNumber(e, setMaxEligibleDaysBeforeMaturity)
              }
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Threshold LTV (%)"
              value={thresholdLtv}
              setState={(e) => handleNumberWithDecimal(e, setThresholdLtv)}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Lock-in Period (Days)"
              value={lockInPeriod}
              setState={(e) => handleOnlyNumber(e, setLockInPeriod)}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Loan Percentage (%)"
              value={loanPercentage}
              setState={(e) => handleNumberWithDecimal(e, setLoanPercentage)}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Number of Loan Active"
              value={activeLoansNumber}
              setState={(e) => handleNumberWithDecimal(e, setActiveLoanNumber)}
            />
          </Grid>
        </Grid>
      </Grid>

      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}

      {callInProgress && <CircularProgresss callInProgress />}
    </Grid>
  );
};

export default RenewalTopUpValidationCreate;
